<div class="{{box.style}} w-100">
	<div class="container" *ngIf="metricRows">
		<!-- PRINT ROWS -->
		<div ds-metric-row
         *ngFor="let metricRow of (metricRows | async)"
         [metricRow]="metricRow"
         class="row"
		></div>
	</div>
</div>
